function removeRequired(element) {
	element.querySelector("span").remove();
	element.querySelector("input").removeAttribute("required");
	return;
}
const placeholders = [
	"A unicorn filled with glitter!",
	"A taco piñata that spills out tiny tacos!",
	"A galaxy-themed piñata!",
	"A robot that spills out gears and candy!",
	"A rainbow piñata with a pot of gold candy!",
];
function updatePlaceholderLoop(textarea) {
	let currentIndex = 0;
	const textArea = document.getElementById("idea");

	function updatePlaceholder() {
		textArea.placeholder = placeholders[currentIndex];
		currentIndex = (currentIndex + 1) % placeholders.length;
	}

	setInterval(updatePlaceholder, 2000);

	// Initial placeholder update
	updatePlaceholder();
}
function suggestClick() {
	const title = document.querySelector("h1#title");
	const name = document.querySelector("label[for='contactFormName'");
	const email = document.querySelector("label[for='contactFormEmail'");
	const message = document.querySelector("label[for='contactFormMessage'");
	const send = document.querySelector("input[type='submit']");
	document.querySelector("#isorder").remove();
	title.innerHTML = "🎉 What's Your Piñata Idea?";
	removeRequired(name);
	removeRequired(email);
	message.querySelector("p").innerText = "Share Your Creative Idea! *";
	send.value = "🎈 Submit Your Idea!";
	document.querySelector("#suggestbutton").remove();
	let index = Math.floor(Math.random() * length);
	function updatePlaceholder() {
		message
			.querySelector("textarea")
			.setAttribute("placeholder", placeholders[index]);
		index = (index + 1) % placeholders.length;
	}
	setInterval(updatePlaceholder, 2000);
	updatePlaceholder();
}
